import Image from 'next/image'
import { useMedia } from 'react-use'

import { Section, SectionTitle } from 'react-scale/components'

const LabelingTaxonomies = ({ labels }) => {
   const isMobile = useMedia('(max-width: 767px)')

   const TEMPLATE = {
      tick: {
         icon: {
            src:  "/static/images/pages/open-datasets/oxford/data-annotation/check.svg",
            alt:  "check",
            width: isMobile ? 13 : 18,
            height: isMobile ? 9 : 13
         },
         color: "#AAD2FF",
      },
      score: {
         icon: {
            src: "/static/images/pages/open-datasets/oxford/data-annotation/score.svg",
            alt:  "score",
            width: isMobile ? 15 : 18,
            height: 5
         },
         color: "#6BB0FF",
      },
      cross: {
         icon: {
            src: "/static/images/pages/open-datasets/oxford/data-annotation/cross.svg",
            alt:  "score",
            width: isMobile ? 10 : 14,
            height: isMobile ? 10 : 14
         }
      },
      question: {
         icon: {
            src: "/static/images/pages/open-datasets/oxford/data-annotation/question.svg",
            alt:  "score",
            width: isMobile ? 9 : 12,
            height: isMobile ? 16 : 19
         }
      },
   }

   return (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 lg:gap-x-16 xl:gap-x-12 gap-y-12 lg:gap-y-14 sm:max-w-none">
         {labels.map((label, index) => {
            const labelOptions = TEMPLATE[label.type]

            return (
               // eslint-disable-next-line react/no-array-index-key
               <div className="space-y-6 md:space-y-8" key={index}>
                  <div className="space-y-6 md:space-y-3 border-l-2 border-tundora pl-6 lg:max-w-[390px] xl:max-w-[440px]">
                     <div className="flex items-center space-x-4">
                        <p style={{ color: labelOptions.color ?? '#FFFFFF' }} className="text-4xl leading-10 md:text-5xl md:leading-[72px] font-aeonik">
                           {label.title}
                        </p>
                        <span
                           style={{ backgroundColor: labelOptions.color ?? '#404040' }}
                           className="rounded-full text-2xl w-[31px] h-[31px] md:w-[39px] md:h-[39px] flex items-center justify-center"
                        >
                           <Image
                              loading="eager"
                              src={labelOptions.icon.src}
                              width={labelOptions.icon.width}
                              height={labelOptions.icon.height}
                              alt={labelOptions.icon.alt}
                           />
                        </span>
                     </div>
                     <p className="xl:text-lg leading-8" dangerouslySetInnerHTML={{ __html: label.subtitle }} />
                  </div>
                  {label.body}
               </div>
            )
         })}
      </div>
   )
}

const DataAnnotation = () => (
   <Section bg="bg-black">
      <SectionTitle
         themeColors={{ overtitleColor: '#AAD2FF' }}
         overtitle="data annotation"
         title="Labeling Taxonomies"
      />

      <LabelingTaxonomies
         labels={[
            {
               title: "Agree",
               subtitle: 'The reply shows approval towards the initial statement or initial&nbsp;author.',
               body: <p className="text-sm text-silver pl-6 leading-6 md:leading-7">Some examples of phrases that express agreement are: “I agree”,<br className='hidden xl:block' /> “That’s absolutely right”, “That’s so true”, “Exactly”, “That’s how I feel”,&nbsp;etc.</p>,
               type: "tick"
            },
            {
               title: "Neutral",
               subtitle: "There is a topical exchange between authors but agreement / disagreement is not&nbsp;expressed.",
               type: "score"
            },
            {
               title: "Disagree",
               subtitle: "The reply shows disapproval or dislike towards the initial statement or initial&nbsp;author.",
               body: <p className="text-sm text-silver pl-6 leading-6 md:leading-7">Some examples of phrases that express disagreement are: “No way”,<br className='hidden xl:block' /> “I don’t think so”, “Not necessarily”, “That’s not always true”,&nbsp;etc.</p>,
               type: "cross"
            },
            {
               title: "Unsure",
               subtitle: "It is not possible to make a decision based on the information at&nbsp;hand.",
               type: "question"
            }
         ]}
      />
   </Section>
)

export default DataAnnotation
